module.exports = __webpack_public_path__ + "img/bg66.1c83bf8d.png";